/* eslint-disable prettier/prettier */
<template>
	<v-container fluid>
		<v-layout row>
			<!-- Login Error Message -->
			<v-flex xs8 offset-xs2>
				<v-alert
					id="invalid-credentials-alert"
					transition="fade-transition"
					:value="showLoginError"
					type="error"
					color="error"
					class="mb-4"
					>Invalid username or password</v-alert
				>
			</v-flex>

			<v-flex xs12>
				<!-- Login Form -->
				<v-form v-model="valid" class="form login-form">
					<!-- Email -->
					<v-layout row>
						<v-flex xs12>
							<v-text-field
								id="username"
								v-model="email"
								:rules="[rules.required, rules.email]"
								label="Username (e-mail)"
								required
							></v-text-field>
						</v-flex>

						<v-flex xs12>
							<v-text-field
								id="password"
								v-model="password"
								:append-icon="show ? 'fa-eye-slash' : 'fa-eye'"
								:rules="[rules.required]"
								label="Password"
								:type="show ? 'text' : 'password'"
								name="password-input"
								@click:append="show = !show"
							></v-text-field>
						</v-flex>

						<!-- Submit Login Request -->
						<v-flex xs4 offset-xs9>
							<v-btn
								id="submit"
								v-on:click="logUserIn"
								style="
                                    background-color: var(--accent-color);
                                    color: var(--text-color-white)"
								>Submit</v-btn
							>
						</v-flex>
					</v-layout>
				</v-form>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<!-- Script -->
<script>
import firebase from 'firebase/app';
export default {
	name: 'LoginForm',
	data: function() {
		return {
			valid: false,
			show: false,
			showLoginError: false,
			loginErrorMessage: '',
			email: '',
			password: '',
			rules: {
				required: value => !!value || 'Required',
				email: value => /.+@.+/.test(value) || 'Invalid email'
			}
		};
	},
	methods: {
		logUserIn: function() {
			this.showLoginError = false;
			const parent = this;
			firebase
				.auth()
				.signInWithEmailAndPassword(this.email, this.password)
				.then(function() {
					parent.$router.replace('account');
				})
				.catch(function() {
					parent.showLoginError = !parent.showLoginError;
				});
		}
	}
};
</script>
